/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.pageHeight = window.innerHeight;
      this.lastKnownScrollY = 0;
      this.ticking = false;
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('touchstart', this.onClick, {
        passive: true
      });
      // Recalculate pageHeight on resize
      window.addEventListener('resize', () => {
        this.pageHeight = window.innerHeight;
      }, { passive: true });
      // Use ticking pattern to batch scroll updates
      window.addEventListener('scroll', () => {
        this.lastKnownScrollY = window.scrollY;
        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.updateVisibility(this.lastKnownScrollY);
            this.ticking = false;
          });
          this.ticking = true;
        }
      }, { passive: true });
    }

    updateVisibility(scrollY) {
      if (scrollY > this.pageHeight) {
        this.classList.add('back-to-top--active');
      } else {
        this.classList.remove('back-to-top--active');
      }
    }

    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
  customElements.define('back-to-top', BackToTop);
}